import Store from "@/store/index";

import Employees from "@/pages/employees";
import EmployeesList from "@/pages/employees/list";
import EmployeesPeriodReports from "@/pages/employees/period-reports";
import EmployeesReports from "@/pages/employees/reports";

import { userPermissionsList } from "@/constants/userPermissions";

export default [
    {
        path: "/employees",
        component: Employees,
        children: [
            {
                path: "employees-list",
                name: "employees-list",
                component: EmployeesList,
                meta: {
                    title: "Сотрудники",
                },
            },
            {
                path: "period-reports",
                name: "employees-period-reports",
                component: EmployeesPeriodReports,
                meta: {
                    title: "Сотрудники — отчеты по периоду",
                },
            },
            {
                path: "reports",
                name: "employees-reports",
                component: EmployeesReports,
                meta: {
                    title: "Сотрудники — отчеты",
                },
            },
            {
                path: "employees-map",
                name: "employees-map",
                component: () => import("@/pages/employees/map"),
                meta: {
                    title: "Сотрудники — на карте",
                },
                beforeEnter: async (to, from, next) => {
                    let firstPermission = false;
                    let secondPermission = false;

                    const workerPermissions = [
                        userPermissionsList.worker.viewAll,
                        userPermissionsList.worker.viewOwn,
                        userPermissionsList.worker.controlAll,
                        userPermissionsList.worker.controlOwn,
                    ];
                    const worksheetPermissions = [
                        userPermissionsList.worker.worksheet.view,
                        userPermissionsList.worker.worksheet.control,
                    ];

                    await Store.dispatch("getUserPermissions");

                    const userPermissions = Store.state.userPermissions;

                    userPermissions.forEach((permission) => {
                        if (workerPermissions.includes(permission)) {
                            firstPermission = true;
                        }
                        if (worksheetPermissions.includes(permission)) {
                            secondPermission = true;
                        }
                    });

                    if (firstPermission && secondPermission) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                },
            },
        ],
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                next();
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
